// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AVUzt","left":"styles_left__pNyPx","desktopActions":"styles_desktopActions__3nsM0","title":"styles_title__10ANI"};